import { PCM16_CONVERSION } from "../constants/audio.constants";

export const base64ToArrayBuffer = (base64: string): ArrayBuffer => {
  const binaryString = window.atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};

export const shouldDebounceTranscription = (
  currentText: string,
  lastTranscription: { text: string; timestamp: number },
  debounceMs: number
): boolean => {
  const now = Date.now();
  return (
    currentText === lastTranscription.text &&
    now - lastTranscription.timestamp < debounceMs
  );
};

/**
 * Convert Float32Array audio data to PCM16 format (Int16Array)
 * Clamps values to [-1, 1] range and converts to 16-bit PCM
 */
export const convertToPCM16 = (float32Array: Float32Array): Int16Array => {
  const pcm16 = new Int16Array(float32Array.length);
  for (let i = 0; i < float32Array.length; i++) {
    // Clamp to [-1, 1] range
    const clamped = Math.max(
      PCM16_CONVERSION.MIN_VALUE,
      Math.min(PCM16_CONVERSION.MAX_VALUE, float32Array[i])
    );
    // Convert to 16-bit PCM
    pcm16[i] =
      clamped < 0
        ? clamped * PCM16_CONVERSION.NEGATIVE_MULTIPLIER
        : clamped * PCM16_CONVERSION.POSITIVE_MULTIPLIER;
  }
  return pcm16;
};
